import { request } from "./api-client";
import type { AdminCampaign, AdminCampaignInput } from "./types";

export async function listCampaigns(): Promise<{ data: AdminCampaign[] }> {
  return request("/campaigns");
}

export async function createCampaign(input: AdminCampaignInput): Promise<{ data: AdminCampaign }> {
  return request("/campaigns", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export async function updateCampaign(
  id: string,
  input: AdminCampaignInput,
): Promise<{ data: AdminCampaign }> {
  return request(`/campaigns/${id}`, {
    method: "PATCH",
    body: JSON.stringify(input),
  });
}

export async function deleteCampaign(id: string): Promise<{ success: boolean }> {
  return request(`/campaigns/${id}`, {
    method: "DELETE",
  });
}
